import { render, staticRenderFns } from "./out_class_other.vue?vue&type=template&id=2ec6e403"
import script from "./out_class_other.vue?vue&type=script&lang=js"
export * from "./out_class_other.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports